<template>
<div class="chapter">
<div class="inner_page">
<h1 title="A Trust Betrayed"></h1>
<div class="figure"><img alt="ATrustBetrayed" src="Images/ATrustBetrayed.jpg"/></div>
<h1 class="sigil_not_in_toc">A Trust Betrayed</h1>
<h3 class="sigil_not_in_toc"><i>The Margaret Kerr Series: Book One</i></h3>
<h3 class="sigil_not_in_toc">Candace Robb</h3>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TB_title.vue?1a38cf3b